import { DateField, SelectField, TextField } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

const GlobalSearchDesktopJobs = (props) => (
  <Fragment>
    <div>
      <TextField
        name="SampleID"
        title={i18n.t('globalSearch:Your Sample ID')}
        value={props.formData.SampleID}
        onChange={props.onFormChange}
      />
      <TextField
        name="MaxxamJobNumber"
        title={i18n.t('globalSearch:Job #')}
        value={props.formData.MaxxamJobNumber}
        onChange={props.onFormChange}
      />
      <SelectField
        name="SubmissionTypeId"
        title={i18n.t('globalSearch:Submission Type')}
        options={props.submissionTypeOptions}
        value={props.formData.SubmissionTypeId}
        onChange={props.onFormChange}
      />
    </div>
    <div>
      <TextField
        name="MaxxamSampleNumber"
        title={i18n.t('globalSearch:Sample #')}
        value={props.formData.MaxxamSampleNumber}
        onChange={props.onFormChange}
      />
      <TextField
        name="ECoCNumber"
        title={i18n.t('globalSearch:eCOC #')}
        value={props.formData.ECoCNumber}
        onChange={props.onFormChange}
      />
      <SelectField
        name="Status"
        title={i18n.t('globalSearch:Status')}
        value={props.formData.Status}
        onChange={props.onFormChange}
        options={props.jobStatusOptions}
      />
    </div>
    <div>
      <TextField
        name="ProjectNumber"
        title={i18n.t('globalSearch:Project #')}
        value={props.formData.ProjectNumber}
        onChange={props.onFormChange}
      />
      <TextField
        name="CoCNumber"
        title={i18n.t('globalSearch:COC #')}
        value={props.formData.CoCNumber}
        onChange={props.onFormChange}
      />
      <SelectField
        name="ClientNumber"
        title={i18n.t('globalSearch:Client')}
        value={props.formData.ClientNumber}
        onChange={props.onFormChange}
        options={props.clientOptions}
      />
    </div>
    <div>
      <TextField
        name="SiteLocationOrSiteNumber"
        title={i18n.t('globalSearch:Site Location / Site #')}
        value={props.formData.SiteLocationOrSiteNumber}
        onChange={props.onFormChange}
      />
      <TextField
        name="Attention"
        title={i18n.t('globalSearch:Attention')}
        value={props.formData.Attention}
        onChange={props.onFormChange}
      />
      <SelectField
        name="DateType"
        title={i18n.t('globalSearch:Date Type')}
        value={props.formData.DateType}
        onChange={props.onFormChange}
        options={props.dateTypeJobsOptions}
      />
    </div>
    <div>
      <TextField
        name="POAFENumber"
        title={i18n.t('globalSearch:PO #')}
        value={props.formData.POAFENumber}
        onChange={props.onFormChange}
      />
      <TextField
        name="invoiceNumber"
        title={i18n.t('globalSearch:Invoice #')}
        value={props.formData.invoiceNumber}
        onChange={props.onFormChange}
      />
      <div className="global-search__desktop__container__grid__split">
        <DateField
          name="DateFrom"
          title={i18n.t('globalSearch:From')}
          value={props.formData.DateFrom}
          onChange={props.onFormChange}
        />
        <DateField
          name="DateTo"
          title={i18n.t('globalSearch:To')}
          value={props.formData.DateTo}
          onChange={props.onFormChange}
        />
      </div>
    </div>
    {props.hasAccessToAA && (
      <div>
        <TextField
          name="AdditionNumber"
          title={i18n.t('additionalAnalysis:AdditionNo')}
          value={props.formData.AdditionNumber}
          onChange={props.onFormChange}
        />
        <div />
        <div />
      </div>
    )}
  </Fragment>
);

GlobalSearchDesktopJobs.propTypes = {
  onFormChange: PropTypes.func,
  hasAccessToAA: PropTypes.bool,
  formData: PropTypes.shape({
    SampleID: PropTypes.string,
    MaxxamJobNumber: PropTypes.string,
    MaxxamSampleNumber: PropTypes.string,
    ECoCNumber: PropTypes.string,
    CoCNumber: PropTypes.string,
    Attention: PropTypes.string,
    Status: PropTypes.string,
    invoiceNumber: PropTypes.string,
    Description: PropTypes.string,
    InvoiceAttention: PropTypes.string,
    SubmissionTypeId: PropTypes.number,
    ProjectNumber: PropTypes.string,
    ReportAttention: PropTypes.string,
    ClientNumber: PropTypes.string,
    SiteLocationOrSiteNumber: PropTypes.string,
    CreatedByName: PropTypes.string,
    AdditionNumber: PropTypes.string,
    DateType: PropTypes.string,
    POAFENumber: PropTypes.string,
    ModifiedByName: PropTypes.string,
    DateFrom: PropTypes.string,
    DateTo: PropTypes.string,
  }),
  jobStatusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  clientOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  submissionTypeOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  dateTypeJobsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
};

export default GlobalSearchDesktopJobs;



// WEBPACK FOOTER //
// ./src/components/GlobalSearch/GlobalSearchDesktop/GlobalSearchDesktopJobs/GlobalSearchDesktopJobs.jsx